// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton-links-block {
  margin-bottom: 15px;
  --padding-start: 16px;
}
.skeleton-links-block__icon {
  width: 40px;
  height: 40px;
  margin-inline-end: 12px;
  border-radius: 8px;
  overflow: hidden;
}
.skeleton-links-block__icon ion-skeleton-text {
  width: 100%;
  height: 100%;
  margin: 0;
  border-radius: 8px;
}
.skeleton-links-block__label {
  margin: 0;
}
.skeleton-links-block__line {
  margin: 0 0 8px;
}
.skeleton-links-block__line ion-skeleton-text {
  margin: 0;
  height: 16px;
}
.skeleton-links-block__line--primary ion-skeleton-text {
  width: 68%;
}
.skeleton-links-block__line--secondary ion-skeleton-text {
  width: 40%;
  height: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/links/skeleton-links-block/skeleton-links-block.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,qBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AACN;AAGE;EACE,SAAA;AADJ;AAIE;EACE,eAAA;AAFJ;AAII;EACE,SAAA;EACA,YAAA;AAFN;AAKI;EACE,UAAA;AAHN;AAMI;EACE,UAAA;EACA,YAAA;AAJN","sourcesContent":[".skeleton-links-block {\n  margin-bottom: 15px;\n  --padding-start: 16px;\n\n  &__icon {\n    width: 40px;\n    height: 40px;\n    margin-inline-end: 12px;\n    border-radius: 8px;\n    overflow: hidden;\n\n    ion-skeleton-text {\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      border-radius: 8px;\n    }\n  }\n\n  &__label {\n    margin: 0;\n  }\n\n  &__line {\n    margin: 0 0 8px;\n\n    ion-skeleton-text {\n      margin: 0;\n      height: 16px;\n    }\n\n    &--primary ion-skeleton-text {\n      width: 68%;\n    }\n\n    &--secondary ion-skeleton-text {\n      width: 40%;\n      height: 14px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
